<ag-grid-angular
  style="width: 100%; height: 100%"
  class="ag-bcdfx"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [toolPanelSuppressSideButtons]="true"
  [frameworkComponents]="frameworkComponents"
  enableColResize
  enableSorting
  singleClickEdit
  (contextmenu)="handleClick($event)"
  multiSortKey="ctrl"
>
</ag-grid-angular>
<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
